(() => {
  const initSection = (sectionEl) => {
    if (!sectionEl || sectionEl.dataset.ncInitialized === 'true') return;
    sectionEl.dataset.ncInitialized = 'true';

    const sectionId = sectionEl.dataset.sectionId;
    const isSearchPage = window.location.pathname.includes('/search');
    let cachedFilterResponse = null; // Cache for mobile filter results
    let isFilterLoading = false; // Block rapid filter clicks
    
    const selectors = {
      layout: '#layout-' + sectionId,
      form: '#FilterForm-' + sectionId,
      gridContainer: '#ProductGridContainer',
      sort: '#Sort-' + sectionId,
      searchInput: '#CollectionSearch-' + sectionId,
      searchResults: '#PredictiveResults-' + sectionId,
      searchForm: '#SearchForm-' + sectionId,
      searchContainer: '.nc-search',
      searchLoading: '.nc-search-loading',
      filtersToggle: '.nc-filters-toggle',
      filtersWrapper: '#filters-' + sectionId,
      filtersOverlay: '[data-filters-overlay]',
      mobileFilterOpen: '.nc-mobile-filter-open',
      filtersClose: '.nc-filters-close'
    };

    const getSectionUrl = (params) => {
      const baseUrl = `${window.location.pathname}?section_id=${sectionId}`;
      const queryString = params.toString();
      return queryString ? `${baseUrl}&${queryString}` : baseUrl;
    };

    const updateUrl = (params) => {
      const queryString = params.toString();
      const newUrl = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    };

    const renderSection = async (params) => {
      const layout = sectionEl.querySelector(selectors.layout);
      if (!layout) return;

      layout.setAttribute('data-loading', 'true');

      try {
        const response = await fetch(getSectionUrl(params));
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newSection = doc.querySelector('[data-collection-section][data-section-id="' + sectionId + '"]');
        const newLayout = newSection ? newSection.querySelector(selectors.layout) : null;

        if (newLayout) {
          layout.innerHTML = newLayout.innerHTML;
          attachEvents();
          refreshCampaignPrices();
        }

        updateUrl(params);
      } catch (error) {
        console.error('Collection filters fetch error', error);
      } finally {
        layout.removeAttribute('data-loading');
      }
    };

    const submitForm = (form) => {
      const params = new URLSearchParams(new FormData(form));
      
      // Preserve search query on search page
      if (isSearchPage) {
        const currentParams = new URLSearchParams(window.location.search);
        const searchQuery = currentParams.get('q');
        const searchType = currentParams.get('type');
        if (searchQuery) params.set('q', searchQuery);
        if (searchType) params.set('type', searchType);
      }
      
      renderSection(params);
    };

    const onFormSubmit = (event) => {
      event.preventDefault();
      submitForm(event.currentTarget);
    };

    const isMobile = () => window.innerWidth < 1200;

    const setFiltersLoading = (loading) => {
      isFilterLoading = loading;
      const filtersBody = sectionEl.querySelector('.nc-filters-body');
      if (filtersBody) {
        filtersBody.classList.toggle('is-loading', loading);
      }
    };

    const updateMobileFilterCount = async (form) => {
      if (isFilterLoading) return; // Block if already loading
      
      setFiltersLoading(true);
      
      const params = new URLSearchParams(new FormData(form));
      
      if (isSearchPage) {
        const currentParams = new URLSearchParams(window.location.search);
        const searchQuery = currentParams.get('q');
        const searchType = currentParams.get('type');
        if (searchQuery) params.set('q', searchQuery);
        if (searchType) params.set('type', searchType);
      }

      try {
        const response = await fetch(getSectionUrl(params));
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        
        // Cache the response for instant apply
        cachedFilterResponse = {
          doc,
          params
        };
        
        // Update product count in button
        const countEl = doc.querySelector('[data-product-count]');
        const count = countEl ? countEl.textContent : '0';
        
        const mobileFooter = sectionEl.querySelector('[data-mobile-footer]');
        const showBtn = mobileFooter ? mobileFooter.querySelector('[data-mobile-show-filters]') : null;
        if (showBtn) {
          showBtn.textContent = `Pokaż produkty (${count})`;
        }
        
        // Update filter counts in sidebar
        const newFiltersBody = doc.querySelector('.nc-filters-body');
        const currentFiltersBody = sectionEl.querySelector('.nc-filters-body');
        if (newFiltersBody && currentFiltersBody) {
          // Get current checked state
          const checkedInputs = new Set();
          currentFiltersBody.querySelectorAll('input[type="checkbox"]:checked').forEach(input => {
            checkedInputs.add(input.id);
          });
          
          // Update filters HTML
          currentFiltersBody.innerHTML = newFiltersBody.innerHTML;
          
          // Restore checked state
          checkedInputs.forEach(id => {
            const input = currentFiltersBody.querySelector('#' + id);
            if (input) input.checked = true;
          });
          
          // Re-attach form events
          const newForm = currentFiltersBody.querySelector('form');
          if (newForm) {
            newForm.addEventListener('submit', onFormSubmit);
            newForm.addEventListener('change', onFormChange);
          }
        }
      } catch (error) {
        console.error('Error fetching count', error);
      } finally {
        setFiltersLoading(false);
      }
    };
    
    const applyCachedFilterResponse = () => {
      if (!cachedFilterResponse) return false;
      
      const { doc, params } = cachedFilterResponse;
      const layout = sectionEl.querySelector(selectors.layout);
      if (!layout) return false;
      
      const newSection = doc.querySelector('[data-collection-section][data-section-id="' + sectionId + '"]');
      const newLayout = newSection ? newSection.querySelector(selectors.layout) : null;
      
      if (newLayout) {
        layout.innerHTML = newLayout.innerHTML;
        attachEvents();
        refreshCampaignPrices();
        updateUrl(params);
        cachedFilterResponse = null; // Clear cache after use
        return true;
      }
      
      return false;
    };

    const updateMobileClearButtonVisibility = () => {
      const form = sectionEl.querySelector(selectors.form);
      const mobileFooter = sectionEl.querySelector('[data-mobile-footer]');
      if (!form || !mobileFooter) return;
      
      const hasChecked = form.querySelectorAll('input[type="checkbox"]:checked').length > 0;
      const clearBtn = mobileFooter.querySelector('[data-mobile-clear-filters]');
      if (clearBtn) {
        clearBtn.classList.toggle('hidden', !hasChecked);
      }
    };

    const onFormChange = (event) => {
      const target = event.target;
      if (!target) return;
      const form = target.closest(selectors.form);
      if (!form) return;

      const type = (target.type || '').toLowerCase();
      const autoTypes = ['checkbox', 'radio', 'select-one', 'select-multiple'];

      if (autoTypes.includes(type)) {
        if (isMobile()) {
          // Na mobile tylko aktualizuj licznik i widoczność przycisku clear
          updateMobileFilterCount(form);
          updateMobileClearButtonVisibility();
        } else {
          // Na desktop od razu filtruj
          submitForm(form);
        }
      }
    };

    const onSortChange = (event) => {
      const select = event.target;
      const form = sectionEl.querySelector(selectors.form);
      const params = form ? new URLSearchParams(new FormData(form)) : new URLSearchParams(window.location.search);

      if (select.value) {
        params.set('sort_by', select.value);
      } else {
        params.delete('sort_by');
      }

      // Preserve search query on search page
      if (isSearchPage) {
        const currentParams = new URLSearchParams(window.location.search);
        const searchQuery = currentParams.get('q');
        const searchType = currentParams.get('type');
        if (searchQuery) params.set('q', searchQuery);
        if (searchType) params.set('type', searchType);
      }

      renderSection(params);
    };

    const openFiltersDrawer = () => {
      const filters = sectionEl.querySelector(selectors.filtersWrapper);
      const overlay = sectionEl.querySelector(selectors.filtersOverlay);
      const mobileFooter = sectionEl.querySelector('[data-mobile-footer]');
      if (!filters) return;
      filters.classList.add('is-open');
      if (overlay) overlay.classList.add('is-visible');
      if (mobileFooter) mobileFooter.classList.add('is-visible');
      document.body.classList.add('nc-filters-locked');
    };

    const closeFiltersDrawer = () => {
      const filters = sectionEl.querySelector(selectors.filtersWrapper);
      const overlay = sectionEl.querySelector(selectors.filtersOverlay);
      const mobileFooter = sectionEl.querySelector('[data-mobile-footer]');
      if (filters) filters.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-visible');
      if (mobileFooter) mobileFooter.classList.remove('is-visible');
      document.body.classList.remove('nc-filters-locked');
    };

    const onSearchSubmit = (event) => {
      event.preventDefault();
      const searchInput = sectionEl.querySelector(selectors.searchInput);
      const searchValue = searchInput ? searchInput.value.trim() : '';
      
      if (!searchValue) return;
      
      // Przekieruj na stronę wyszukiwania z filtrem typu product
      const searchParams = new URLSearchParams();
      searchParams.set('q', searchValue);
      searchParams.set('type', 'product');
      
      window.location.href = `/search?${searchParams.toString()}`;
    };

    const attachSearch = () => {
      const searchForm = sectionEl.querySelector('[data-collection-search]');
      if (searchForm) {
        searchForm.addEventListener('submit', onSearchSubmit);
      }
    };

    const onFiltersToggle = (event) => {
      const filters = sectionEl.querySelector(selectors.filtersWrapper);
      if (!filters) return;
      const collapsed = filters.dataset.collapsed === 'true';
      filters.dataset.collapsed = collapsed ? 'false' : 'true';
      event.currentTarget.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
      event.currentTarget.textContent = collapsed ? 'Zwiń' : 'Pokaż';
    };

    const onMobileFilterOpen = () => openFiltersDrawer();
    const onMobileFilterClose = () => closeFiltersDrawer();

    const onClearFiltersClick = async (event) => {
      event.preventDefault();
      event.stopPropagation();
      
      const form = sectionEl.querySelector(selectors.form);
      if (!form) return;
      
      // Odznacz wszystkie checkboxy
      const checkboxes = form.querySelectorAll('input[type="checkbox"]:checked');
      checkboxes.forEach(cb => cb.checked = false);
      
      // Wyczyść pola cenowe
      const priceInputs = form.querySelectorAll('input[type="number"]');
      priceInputs.forEach(input => input.value = '');
      
      // Preserve search query on search page
      const params = new URLSearchParams();
      if (isSearchPage) {
        const currentParams = new URLSearchParams(window.location.search);
        const searchQuery = currentParams.get('q');
        const searchType = currentParams.get('type');
        if (searchQuery) params.set('q', searchQuery);
        if (searchType) params.set('type', searchType);
      }
      
      renderSection(params);
    };

    const initSortDropdown = () => {
      const dropdown = sectionEl.querySelector('[data-sort-dropdown]');
      if (!dropdown) return;
      
      const trigger = dropdown.querySelector('[data-sort-trigger]');
      const label = dropdown.querySelector('[data-sort-label]');
      const select = dropdown.querySelector('select');
      const items = dropdown.querySelectorAll('[data-sort-value]');
      
      if (!trigger || !label || !select) return;
      
      // Toggle dropdown
      trigger.addEventListener('click', (e) => {
        e.stopPropagation();
        dropdown.classList.toggle('is-open');
      });
      
      // Close on outside click
      const closeDropdown = (e) => {
        if (!dropdown.contains(e.target)) {
          dropdown.classList.remove('is-open');
        }
      };
      document.addEventListener('click', closeDropdown);
      
      // Handle item selection
      items.forEach(item => {
        item.addEventListener('click', () => {
          const value = item.dataset.sortValue;
          const text = item.textContent.trim();
          
          // Update label
          label.textContent = text;
          
          // Update hidden select
          select.value = value;
          
          // Update active state
          items.forEach(i => i.classList.remove('active'));
          item.classList.add('active');
          
          // Close dropdown
          dropdown.classList.remove('is-open');
          
          // Trigger change event
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    };

    const attachEvents = () => {
      const form = sectionEl.querySelector(selectors.form);
      if (form) {
        form.addEventListener('submit', onFormSubmit);
        form.addEventListener('change', onFormChange);
      }

      const sortSelect = sectionEl.querySelector(selectors.sort);
      if (sortSelect) {
        sortSelect.addEventListener('change', onSortChange);
      }

      const filtersToggle = sectionEl.querySelector(selectors.filtersToggle);
      if (filtersToggle) {
        filtersToggle.addEventListener('click', onFiltersToggle);
      }

      const mobileFilterOpen = sectionEl.querySelector(selectors.mobileFilterOpen);
      if (mobileFilterOpen) {
        mobileFilterOpen.addEventListener('click', onMobileFilterOpen);
      }

      const filtersClose = sectionEl.querySelector(selectors.filtersClose);
      if (filtersClose) {
        filtersClose.addEventListener('click', onMobileFilterClose);
      }

      const filtersOverlay = sectionEl.querySelector(selectors.filtersOverlay);
      if (filtersOverlay) {
        filtersOverlay.addEventListener('click', onMobileFilterClose);
      }

      const clearFiltersBtn = sectionEl.querySelector('[data-clear-filters]');
      if (clearFiltersBtn) {
        clearFiltersBtn.addEventListener('click', onClearFiltersClick);
      }

      // Mobile footer buttons
      const mobileFooter = sectionEl.querySelector('[data-mobile-footer]');
      if (mobileFooter) {
        const mobileShowBtn = mobileFooter.querySelector('[data-mobile-show-filters]');
        if (mobileShowBtn) {
          mobileShowBtn.addEventListener('click', (e) => {
            e.preventDefault();
            closeFiltersDrawer();
            
            // Try to use cached response first for instant update
            if (!applyCachedFilterResponse()) {
              // Fallback to regular form submit if no cache
              const form = sectionEl.querySelector(selectors.form);
              if (form) {
                submitForm(form);
              }
            }
          });
        }

        const mobileClearBtn = mobileFooter.querySelector('[data-mobile-clear-filters]');
        if (mobileClearBtn) {
          mobileClearBtn.addEventListener('click', onClearFiltersClick);
        }
      }

      const loadMoreBtn = sectionEl.querySelector('[data-load-more]');
      if (loadMoreBtn) {
        loadMoreBtn.addEventListener('click', onLoadMoreClick);
      }

      attachSearch();
      initSortDropdown();
      initAddToCart();
      initActiveFilterTags();
    };

    // Repaint the birthday-campaign strikethrough after AJAX injects new tiles.
    // No-op when the campaign script isn't present or the campaign is off.
    const refreshCampaignPrices = () => {
      if (window.ncCampaignPrice && typeof window.ncCampaignPrice.refresh === 'function') {
        window.ncCampaignPrice.refresh();
      }
    };

    const onLoadMoreClick = async (event) => {
      const button = event.currentTarget;
      const nextUrl = button.dataset.nextUrl;
      if (!nextUrl || button.dataset.loading === 'true') return;

      button.dataset.loading = 'true';
      button.disabled = true;
      const originalText = button.textContent;
      button.textContent = 'Ładowanie...';

      try {
        // Fetch the next page through the lightweight section endpoint so we
        // get just the section markup (not a full page). paginate.next.url
        // already carries the active filters/sort + page param.
        const url = new URL(nextUrl, window.location.origin);
        url.searchParams.set('section_id', sectionId);

        const response = await fetch(url.toString());
        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');

        const currentList = sectionEl.querySelector('#product-list-' + sectionId);
        const newList = doc.getElementById('product-list-' + sectionId);

        if (currentList && newList) {
          Array.from(newList.children).forEach((li) => {
            currentList.appendChild(li.cloneNode(true));
          });

          // Bind add-to-cart on the freshly injected cards (idempotent).
          initAddToCart();

          // Repaint the birthday-campaign strikethrough on the new tiles.
          refreshCampaignPrices();
        }

        // Swap in the next page's button (new data-next-url) or drop it when done.
        const wrapper = button.closest('[data-load-more-wrapper]');
        const newWrapper = doc.querySelector('[data-load-more-wrapper]');
        if (wrapper) {
          if (newWrapper) {
            wrapper.innerHTML = newWrapper.innerHTML;
            const nextButton = wrapper.querySelector('[data-load-more]');
            if (nextButton) nextButton.addEventListener('click', onLoadMoreClick);
          } else {
            wrapper.remove();
          }
        }
      } catch (error) {
        console.error('Load more error', error);
        button.textContent = originalText;
        button.disabled = false;
        button.dataset.loading = 'false';
      }
    };

    const initActiveFilterTags = () => {
      const activeFilters = sectionEl.querySelectorAll('[data-active-filter]');
      activeFilters.forEach(tag => {
        tag.addEventListener('click', async (e) => {
          e.preventDefault();
          const url = new URL(tag.href, window.location.origin);
          const params = new URLSearchParams(url.search);
          
          // Preserve search query on search page
          if (isSearchPage) {
            const currentParams = new URLSearchParams(window.location.search);
            const searchQuery = currentParams.get('q');
            const searchType = currentParams.get('type');
            if (searchQuery && !params.has('q')) params.set('q', searchQuery);
            if (searchType && !params.has('type')) params.set('type', searchType);
          }
          
          renderSection(params);
        });
      });
    };

    const initAddToCart = () => {
      const addToCartButtons = sectionEl.querySelectorAll('.nc-product-add-to-cart');

      addToCartButtons.forEach(button => {
        // Idempotent: skip buttons already bound so re-calling after a
        // "load more" append (below) doesn't double-bind existing cards.
        if (button.dataset.ncAtcBound === 'true') return;
        button.dataset.ncAtcBound = 'true';

        button.addEventListener('click', async (e) => {
          e.preventDefault();
          e.stopPropagation();
          
          const variantId = button.dataset.variantId;
          if (!variantId) return;
          
          const originalText = button.textContent;
          button.textContent = 'Dodawanie...';
          button.disabled = true;
          
          try {
            const response = await fetch('/cart/add.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                id: variantId,
                quantity: 1
              })
            });
            
            if (response.ok) {
              button.textContent = 'Dodano!';
              
              // Odśwież koszyk (jeśli jest funkcja)
              if (typeof window.refreshCart === 'function') {
                window.refreshCart();
              }
              
              // Dispatch event dla innych skryptów
              document.dispatchEvent(new CustomEvent('cart:updated'));
              
              setTimeout(() => {
                button.textContent = originalText;
                button.disabled = false;
              }, 2000);
            } else {
              throw new Error('Failed to add to cart');
            }
          } catch (error) {
            console.error('Add to cart error:', error);
            button.textContent = 'Błąd';
            setTimeout(() => {
              button.textContent = originalText;
              button.disabled = false;
            }, 2000);
          }
        });
      });
    };

    attachEvents();
  };

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-collection-section]').forEach(initSection);
  });

  window.NCCollectionGridInit = initSection;
})();
